import { render, staticRenderFns } from "./actor-bio-appearance.vue?vue&type=template&id=2fda46d6&scoped=true&"
import script from "./actor-bio-appearance.vue?vue&type=script&lang=ts&"
export * from "./actor-bio-appearance.vue?vue&type=script&lang=ts&"
import style0 from "./actor-bio-appearance.vue?vue&type=style&index=0&id=2fda46d6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fda46d6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VForm } from 'vuetify/lib/components/VForm';
import { VRangeSlider } from 'vuetify/lib/components/VRangeSlider';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VCol,VForm,VRangeSlider,VRow,VTextField})
